import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { formatNumber, getData } from "../../../lib/commonFunctions";
import { Alliance } from "../../../lib/types";
import { openContentPopup } from "../../../store/actions";
import { CONTENT_CONTEXT } from "../../../lib/enums";
import GovernorateInfoLink from "../../Common/GovernorateInfoLink";

interface IProps {
  allianceId: number;
}

const AllianceInfo = ({
  allianceId
}: IProps) => {
  const [alliance, setAlliance] = useState<Alliance | null>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const getGovernorate = async () => {
      const governorateData = await getData(`/api/info/alliance/${allianceId}`);
      setAlliance(governorateData);
    };
    getGovernorate();
  }, [allianceId]);

  return (alliance
    ? <>
        <div className="dialog-content">
          <table className="table">
            <tr>
              <th>Members</th>
              <td>{alliance.members.length}</td>
            </tr>
            <tr>
              <th>Emperor</th>
              <td>
                <GovernorateInfoLink
                  name={alliance.emperor.name}
                  govId={alliance.emperor.id}
                  raceName={alliance.emperor.race.name}
                />
              </td>
            </tr>
            <tr>
              <th>Land</th>
              <td>{formatNumber(alliance.land)}</td>
            </tr>
            <tr>
              <th>Power</th>
              <td>{formatNumber(alliance.power)}</td>
            </tr>
            <tr>
              <th>War</th>
              <td>{alliance.war
                ? <span className={"negative"}>At war ({alliance.war.duration}/5)</span> : "Farm"}
              </td>
            </tr>
          </table>
        </div>
        <footer className="dialog-footer">
          <a
            className="btn btn-blank btn-no-width"
            onClick={() => dispatch(openContentPopup({
              name: "OtherAllianceProfile",
              title: alliance.name,
              icon: "popularita",
              alliance,
              reload: true
            }))}
          >
            Detail
          </a>
          <a
            className="btn btn-blank btn-no-width"
            onClick={() => dispatch(openContentPopup({
              name: "Statistics",
              title: "Statistics",
              icon: "statistiky",
              statsType: CONTENT_CONTEXT.Alliance,
              presetSearch: alliance.name
            }))}
          >
            Stats
          </a>
        </footer>
    </> : <></>)
}

export default AllianceInfo;
